import * as systemConfigService from './system-config.service';

export * from './system-config.service';
export default systemConfigService;
